const AppTextFieldConfig = {
    properties: {
        label: "label",
        labelFontColor: "labelFontColor",
        id: "id",
        type: "type",
        value: "value",
        maxLength: "maxLength",
        disabled: "disabled",
        underline: "underline",
        lineColor: "lineColor",
        fontColor: "fontColor",
        paddingTop: "paddingTop",
        paddingBottom: "paddingBottom",
        paddingRight: "paddingRight",
        paddingLeft: "paddingLeft",
        fontWeight: "fontWeight",
        compulsory: "compulsory",
        textFormat: "textFormat",
        placeHolder: "placeHolder",
        prefixType: "prefixType",
        prefix: "prefix",
        validationMode: "validationMode",
        listener: {
            errorLabelGetter: "errorLabelGetter",
            onChange: "onChange",
            onFormat: "onFormat",
            onBlur: "onBlur",
            onValidate: "onValidate",
            onKeyDown: "onKeyDown",
        }
    },
    type: {
        number: "number",
        text: "text"
    },
    compulsory: {
        true: "true",
        false: "false"
    },
    disabled: {
        true: "true",
        false: "false"
    },
    underline: {
        normal: "normal",
        bold: "bold"
    },
    lineColor: {
        black: "black",
        gray: "gray"
    },
    fontColor: {
        black: "black",
        gray: "gray"
    },
    fontWeight: {
        normal: "normal",
        bold: "bold"
    },
    textFormat: {
        normal: "normal",
        allCaps: "allCaps"
    },
    prefixType: {
        none: "none",
        phone: "phone",
        income: "income",
        percent: "percent",
        text: "text"
    },
    validationMode: {
        onChange: "onChange",
        onBlur: "onBlur"
    }
}

export default AppTextFieldConfig